import { logger, RequestUtils } from "@siemensplm/common_utils";
import CapabilityImageMap from "../context/CapabilityImagesMap.json";
import { capabilityType } from "src/types/CommonTypes";

export async function getSiteCapabilities(
  teamsContext: any,
  tcTeamsContext: any
) {
  logger.logInformation("Fetching site capabilities...");

  try {
    const response: any = await RequestUtils.callTcTeamsApi(
      "capability",
      teamsContext.teamsUserCredential,
      tcTeamsContext.teamcenter.session // Pass the session for authenticated calls
    );

    if (response.error) {
      logger.logError(
        `Error fetching site capabilities: ${JSON.stringify(response.error)}`
      );
      return [];
    } else if (response.data) {
      if (Array.isArray(response.data) && response.data.length > 0) {
        logger.logInformation("Site capabilities loaded successfully");
        // Filter out Notifications for Teamcenter capability
        const capabilitiesList = response.data.filter(
          (capability: capabilityType) =>
            !(
              capability.capabilityName === "Notifications" &&
              capability.capabilityDomain === "Teamcenter"
            )
        );

        // Map capabilityImage from CapabilityImagesMap.json
        capabilitiesList.forEach((capability: capabilityType) => {
          capability.capabilityImage =
            CapabilityImageMap.find(
              (cap) =>
                cap.capabilityName === capability.capabilityName &&
                cap.capabilityDomain === capability.capabilityDomain
            )?.capabilityImage || "";
        });

        return capabilitiesList;
      } else {
        logger.logWarning("Site capabilities loaded but empty");
        return []; // Mark as loaded even if empty to prevent retry
      }
    } else {
      logger.logWarning("Site capabilities loaded but no data");
      return []; // Mark as loaded to prevent retry
    }
  } catch (error) {
    logger.logError(
      `Exception in getSiteCapabilities: ${JSON.stringify(error)}`
    );
    return []; // Mark as loaded to prevent retry on error
  }
}
